import { useUpdateAdapterMutation } from '@forge/graphql/generated'
import { useQueryClient } from '@tanstack/react-query'
import { gql } from 'graphql-request'

gql`
  mutation updateAdapter(
    $id: ID!
    $key: String
    $url: String
    $username: String
    $password: String
    $retsVersion: String
    $status: AdapterStatus
    $adapterType: AdapterAdapterType
    $userAgent: String
    $userAgentPassword: String
    $requestTimeZone: String
    $responseTimeZone: String
    $authEndpoint: String
    $grantType: AdapterGrantType
    $scope: String
    $updateDom: Boolean
    $esStatus: AdapterEsStatus
    $useJwtAuth: Boolean
    $resourceBasicAuth: Boolean
    $useReplicationEndpoint: Boolean
    $replicationPrefix: Boolean
  ) {
    updateAdapter(
      id: $id
      key: $key
      url: $url
      username: $username
      password: $password
      rets_version: $retsVersion
      status: $status
      adapter_type: $adapterType
      user_agent: $userAgent
      user_agent_password: $userAgentPassword
      request_time_zone: $requestTimeZone
      response_time_zone: $responseTimeZone
      auth_endpoint: $authEndpoint
      scope: $scope
      update_dom: $updateDom
      es_status: $esStatus
      use_jwt_auth: $useJwtAuth
      grant_type: $grantType
      resource_basic_auth: $resourceBasicAuth
      use_replication_endpoint: $useReplicationEndpoint
      replication_prefix: $replicationPrefix
    ) {
      id
      adapterType: adapter_type
      key
      url
      username
      password
      retsversion: rets_version
      status
      userAgent: user_agent
      userAgentPassword: user_agent_password
      requestTimeZone: request_time_zone
      responseTimeZone: response_time_zone
      authEndPoint: auth_endpoint
      scope
      updateDom: update_dom
      esStatus: es_status
      recordCounts: record_counts {
        today
        listings
        agents
        offices
      }
      useJwtAuth: use_jwt_auth
      grantType: grant_type
      resourceBasicAuth: resource_basic_auth
      useReplicationEndpoint: use_replication_endpoint
      replicationPrefix: replication_prefix
    }
  }
`

export function useUpdateAdapter() {
  const queryClient = useQueryClient()
  return useUpdateAdapterMutation({
    async onSuccess() {
      await queryClient.invalidateQueries(['Adapter'])
    }
  })
}
